import { 
  VIEW_APPEND,
  VIEW_REMOVE
} from './../actions/actions_router'

const initState = {
  view: null, // curent view path
  view_stack: [], // view stack / layers
  container: null, // current view container
  container_stack: [], // container stack / layers
  removed_view: null,
  removed_container: null, // view container being removed
  views_history: [], // all view paths
}

export default (state = initState, action) => {
  switch (action.type) {
    case VIEW_APPEND:
      return { ...state, 
              view: action.payload.view, 
              view_stack: [...state.view_stack, action.payload.view],
              container: action.payload.container,
              container_stack: [...state.container_stack, action.payload.container],
              views_history: [...state.views_history, action.payload.view],
            }
    case VIEW_REMOVE:
      const viewStack = state.view_stack.filter(view => view !== action.payload.view)
      const containerStack = state.container_stack.filter(container => container.id !== action.payload.container.id)
      return { ...state, 
              view: viewStack.length > 0 ? viewStack[viewStack.length - 1] : null,
              view_stack: viewStack,
              container: containerStack.length > 0 ? containerStack[containerStack.length - 1] : null,
              container_stack: containerStack,
              removed_view: action.payload.view,
              removed_container: action.payload.container
            }
    default:
      return state
  }
}